import { DividerDateComponent } from './divider-date.component';

export default angular
  .module('sfMobile.components.divider-date', [
    'pascalprecht.translate',
    'sfMobile.components.divider',
    'sfMobile.services.dates',
  ])
  .component('sfDividerDate', DividerDateComponent).name;
